import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SPORT_PROJECT_IMAGE } from '../config/featuredProject';
import './FeaturedProject.css';

const FeaturedProject = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="featured-project" className="featured-project section">
      <div className="container">
        <div className="featured-project-card glass perspective-container card-3d rounded-2xl shadow-2xl overflow-hidden">
          <div className="featured-project-inner">
            <div className="featured-project-preview featured-project-preview--brand">
              <img
                src={SPORT_PROJECT_IMAGE}
                alt={t.featuredProject.title}
                className="featured-project-image"
                loading="lazy"
              />
              <div className="featured-project-badge">
                <span className="featured-badge-dot"></span>
                {t.featuredProject.badge}
              </div>
            </div>
            <div className="featured-project-content">
              <h2 className="featured-project-title">
                <span className="gradient-text">{t.featuredProject.title}</span>
              </h2>
              <p className="featured-project-description">{t.featuredProject.description}</p>
              <div className="featured-project-actions">
                <a
                  href="#academy-demo"
                  className="featured-cta primary"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('academy-demo');
                  }}
                >
                  {t.featuredProject.viewDemo}
                  <i className="fas fa-external-link-alt"></i>
                </a>
                <button onClick={() => scrollToSection('projects')} className="featured-cta outline">
                  {t.featuredProject.learnMore}
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProject;
